export const baseStyle = [
    'id',
    'type',
    'filter',
    'source',
    'source-layer',
    'minzoom',
    'metadata',
    'maxzoom',
    'paint',
    'layout'
];
export const layoutStyles = [
    'visibility',
    'line-join',
    'line-cap',
    'line-miter-limit',
    'line-round-limit',
    'line-sort-key',
    'circle-sort-key',
    'symbol-avoid-edges',
    'symbol-placement',
    'symbol-sort-key',
    'symbol-spacing',
    'symbol-z-order',
    'icon-allow-overlap',
    'icon-anchor',
    'icon-ignore-placement',
    'icon-image',
    'icon-keep-upright',
    'icon-offset',
    'icon-optional',
    'icon-padding',
    'icon-pitch-alignment',
    'icon-rotate',
    'icon-rotation-alignment',
    'icon-size',
    'icon-text-fit',
    'icon-text-fit-padding',
    'text-allow-overlap',
    'text-anchor',
    'text-field',
    'text-font',
    'text-ignore-placement',
    'text-justify',
    'text-keep-upright',
    'text-letter-spacing',
    'text-line-height',
    'text-max-angle',
    'text-max-width',
    'text-offset',
    'text-optional',
    'text-padding',
    'text-pitch-alignment',
    'text-radial-offset',
    'text-rotate',
    'text-rotation-alignment',
    'text-size',
    'text-transform',
    'text-variable-anchor',
    'text-writing-mode'
];
